import LandingPage from 'src/components/pages/landing';
import dataFetchingUtils from 'src/utils/data-fetching';

export default LandingPage;

export const getStaticProps = dataFetchingUtils.getVicommStaticProps;
